import * as types from './constants';

// Create Lookbook
export const createLookbookRequest = data => (
  { type: types.CREATE_LOOKBOOK_REQUEST, payload: data }
);

export const createLookbookDone = data => (
  { type: types.CREATE_LOOKBOOK_DONE, payload: data }
);

export const createLookbookFailed = errors => (
  { type: types.CREATE_LOOKBOOK_FAILED, payload: errors }
);

export const createLookbookReset = () => (
  { type: types.CREATE_LOOKBOOK_RESET }
);